import { HttpResponse, HttpService, VisibaHttpOption } from '@application/http.service';
import type {
	ClientConditionApiModel,
	GuiComponentApiModel,
	PhysicalLocationApiModel,
	SurveyApiModel,
	UnitAboutApiModel,
	UnitConfigApiModel,
	UnitModel,
} from '@visiba/api-vcs-client-v2';
import { PublicBaseDataApiModel } from '@visiba/api-vcs-general';
import { Injectable } from '@visiba/instantiation';
import { ParameterHandler } from '@visiba/std';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class UnitsApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('units');
	}

	public getTree(unitId: number): HttpResponse<UnitModel> {
		return this.httpService.get(`${this.baseUri}/${unitId}/tree`);
	}

	public getUnitConfig(unitId: number, httpOptions?: VisibaHttpOption): HttpResponse<UnitConfigApiModel> {
		return this.httpService.get(`${this.baseUri}/${unitId}/config/web`, httpOptions);
	}

	public getTexts<T extends string>(receptionId: number, keys: T[]): HttpResponse<{ [K in T]: string | null }> {
		const parameterHandler = new ParameterHandler();
		parameterHandler.append({ aliases: keys.join(',') });

		return this.httpService.get(`${this.baseUri}/${receptionId}/texts${parameterHandler.getString()}`);
	}

	public getLicenseHolderAboutData(unitId: number): HttpResponse<UnitAboutApiModel> {
		return this.httpService.get(`${this.baseUri}/${unitId}/About`);
	}

	// public async getData(unitId: number): HttpResponse<NonNullable<UnitConfigApiModel['Offer']>> {
	// 	const {
	// 		data: { Offer },
	// 	} = await this.httpService.get<UnitConfigApiModel>(`${this.baseUri}/${unitId}/config/app`);

	// 	if (Offer === null) throw new Error('Todo: should never be null');

	// 	return {
	// 		data: Offer,
	// 		successful: true,
	// 		headers: {},
	// 	};
	// }

	public getUnitComponents(unitId: number): HttpResponse<GuiComponentApiModel[]> {
		const url = `${this.baseUri}/${unitId}/guicomponents`;

		return this.httpService.get(url);
	}

	public getLicenseHolderData(alias: string): HttpResponse<PublicBaseDataApiModel> {
		return this.httpService.get(`/general/licenceHolder/${alias}/publicBase`);
	}

	public getConditions(unitId: number): HttpResponse<ClientConditionApiModel[]> {
		return this.httpService.get(`${this.baseUri}/${unitId}/conditions`);
	}

	public getPhysicalLocations(unitId: number, languageCode: string): HttpResponse<PhysicalLocationApiModel[]> {
		const url = this.httpService.createUrl(`${this.baseUri}/${unitId}/physicalLocations`);
		url.searchParams.append('languageCode', languageCode);

		return this.httpService.get(url);
	}

	public survey(alias: string): HttpResponse<SurveyApiModel> {
		return this.httpService.get(`${this.baseUri}/survey/${alias}`);
	}
}
